export function getText(state) {
    let result
    try {
        result = state.locales[state.locale]
    } catch (error) {
        console.info(`Encountered error while setting localized clock items: ${error.message}`)
    }

    if (result == null) {
        // return empty result
        return {
            tooltipText: null,
        }
    }

    return result
}

export function getTooltipText(state) {
    return getText(state).tooltipText
}



// WEBPACK FOOTER //
// ./src/features/Clock/data/clock/selectors.js